export default "__VITE_ASSET__C$BWC0i___"